import { render, staticRenderFns } from "./AccountSetup.vue?vue&type=template&id=448fb7e8"
import script from "./AccountSetup.vue?vue&type=script&lang=ts"
export * from "./AccountSetup.vue?vue&type=script&lang=ts"
import style0 from "./AccountSetup.vue?vue&type=style&index=0&id=448fb7e8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports